import React from 'react';
import './audit-trail-header.scss';

const AuditTrailHeader = ({ title }: { title: string }) => {
  return (
    <div className="audit-trail-header">
      <h2>{title}</h2>
    </div>
  );
};
export default AuditTrailHeader;
